<template>
  <h1 class="system_content_title">评价申诉审核</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
      <el-form-item>
        <el-input clearable v-model="state.searchInput" style="width: 220px; margin-right: 6px"
          placeholder="输入企业名称搜索"></el-input>
        <el-select v-model="state.taskSelect" placeholder="请选择评价工作" style=" margin-right: 6px">
          <el-option v-for="item in state.taskList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="state.statusSelect" style=" margin-right: 6px">

          <el-option label="已提交" :value="1" />
          <el-option label="未提交" :value="0" />
        </el-select>
        <el-select v-model="state.isAuditSelect" style=" margin-right: 6px">

          <el-option label="全部" :value="99" />
          <el-option label="未审核" :value="0" />
          <el-option label="已审核" :value="1" />
        </el-select>

        <el-button type="primary" @click="getTableData" :disabled="!state.taskSelect">搜索</el-button>
      </el-form-item>

      <el-table :data="state.tableData" stripe v-loading="state.loading" style="min-height: 70vh" table-layout="fixed">
        <el-table-column type="selection" width="65"> </el-table-column>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="companyName" label="企业名称" sortable>
        </el-table-column>
        <el-table-column prop="flowStepname" label="当前评审流程" sortable width="140">
        </el-table-column>
        <el-table-column prop="score1" label="自评分数" sortable>
        </el-table-column>
        <el-table-column prop="scorelevel1" label="自评结果">
          <template #default="scope">
            {{ scope.row.scorelevel1.slice(0, 4) }}
          </template>
        </el-table-column>
        <el-table-column prop="scorelevel1" label="自评等级">
          <template #default="scope">
            {{ replaceChinese(scope.row.scorelevel1) }}
          </template>
        </el-table-column>
        <el-table-column prop="score2" label="当前审核分数" sortable width="140">
        </el-table-column>
        <el-table-column prop="scorelevel2" label="当前审核结果">
          <template #default="scope">
            <p v-if="scope.row.scorelevel2 == '未填报' || scope.row.score2 == 0"></p>
            <p v-else-if="scope.row.score2 > 100">无效分数</p>
            <p v-else>{{ scope.row.scorelevel2.slice(0, 4) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="scorelevel2" label="当前审核等级">
          <template #default="scope">
            <p v-if="scope.row.scorelevel2 == '未填报' || scope.row.score2 == 0"></p>
            <p v-else-if="scope.row.score2 > 100">无效分数</p>
            <p v-else>{{ replaceChinese(scope.row.scorelevel2) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="regionFullName" label="行政区划" sortable width="160">
        </el-table-column>
        <el-table-column label="申诉资料" v-if="userStepSelect == '349'" :filters="[
          { text: '已申述', value: 1 },
          { text: '未申诉', value: 0 },
        ]" :filter-method="filterHandler" prop="IsAppealSubmit">
          <template #default="scope">
            <p v-if="scope.row.isAppealSubmit == 1" style="color: red">
              已申诉
            </p>
            <p v-else style="color: green">未申诉</p>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">

            <el-button size="small" type="warning" @click="showDetail(scope.row.id)"
              style="margin-bottom: 2px; margin-right: 2px">前往审核</el-button>
            <br>
            <el-popconfirm title="确定要退回吗？" @confirm="revokeAppeal(scope.row.id)">
              <template #reference>
                <el-button size="small" type="danger" style="margin-bottom: 2px; margin-right: 2px">退回申诉</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="state.pageInfo.pageIndex" :page-sizes="[20, 50, 100, 200, 500, 1000]"
        :page-size="state.pageInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="state.pageInfo.totalRowCount" v-if="state.pageInfo.totalRowCount" class="pageinfo">
      </el-pagination>
    </div>
    <el-dialog v-model="state.addVisible" title="添加企业" width="30%" :before-close="handleClose">
      <el-form label-width="120px">
        <el-form-item label="申诉评价">
          <el-select v-model="state.appealItem" placeholder="请选择" @change="handleChange">
            <el-option v-for="(item, index) in state.audItemList" :key="item.value" :label="item.name" :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申诉内容">
          <el-input v-model="state.appealText" :rows="4" placeholder="请输入内容" type="textarea" />
        </el-form-item>
        <el-form-item label="申诉附件">
          <div class="file_uploaded" v-if="state.appealFile">
            <a download target='_blank' :href="BASE_URL + state.appealFile">{{
              getFileName(state.appealFile)
            }}</a>
            <!-- <el-button type="success">下载</el-button> -->
            <el-button type="danger" style="margin-left: 4px" @click="state.appealFile = ''">删除</el-button>
          </div>
          <div class="file_upload" v-else>
            <el-upload class="item_upload" action="#" :http-request="uploadHandler" accept=".pdf">
              <el-icon class="el-icon--upload"><upload-filled /></el-icon>
              <div class="el-upload__text">点击选择文件</div>
              <template #tip>
                <div class="el-upload__tip">请上传pdf格式的文件</div>
              </template>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer" style="margin: 0 auto">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="saveAppealItem"
            :disabled="!state.audID || !state.appealText || !state.appealFile">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage, ElNotification } from "element-plus";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { DArrowLeft } from "@element-plus/icons-vue";
import CONSTS from "../../store/consts";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const BASE_URL = CONSTS.BASE_URL;
    // if (!route.query.taskID) {
    //   ElMessage({
    //     message: "没有该工作任务，将返回到列表",
    //     type: "error",
    //   });

    //   setTimeout(() => {
    //     router.push("/system/review/reviewTasksListCompany ");
    //   }, 3000);
    // }

    const state = reactive({
      tableData: [],
      taskList: [],
      taskSelect: "",
      loading: false,
      searchInput: "",
      pageInfo: {},
      addVisible: false,
      addSearch: "",
      addSearchLoading: false,
      audItemList: [],
      audID: null,
      audName: null,
      appealText: null,
      appealFile: null,
      companySearchInput: "",
      appealItem: null,
      editItem: null,
      statusSelect: 1,
      isAuditSelect: 99,
    });
    async function getTaskList() {
      const { data } = await api.reviewTaskApi.getTaskList({
        page: 1,
        rows: 99,
        order: "asc",
        sort: "id",
        value: "",
      });
      data.resultObj.data.forEach((item) => {
        state.taskList.push({
          value: item.id,
          label: item.title,
        });
      });
    }
    getTaskList()
    const getTableData = async () => {
      state.loading = true;
      const { data } = await api.auditionApi.getAppealList({
        page: state.pageInfo.pageIndex || 1,
        rows: state.pageInfo.pageSize || 20,
        sort: "",
        value: state.searchInput.trim(),
        headId: state.taskID,
        isAppealSubmit: state.statusSelect,
        isAudit: state.isAuditSelect,
        
        headId: state.taskSelect
        // intId: parseInt(roleId)
      });
      if (data.isSuccessful) {
        state.loading = false;
        state.tableData = data.resultObj.data;
        state.pageInfo = data.resultObj.pagerInfo;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };

    async function getAudItems() {
      const { data } = await api.auditionApi.getAudItemList();
      if (data.isSuccessful) {
        state.audItemList = data.resultObj;
      }
    }
    getAudItems();

    const saveAppealItem = async () => {
      console.info("get task id", state.taskID);
      const { data } = await api.auditionApi.saveAppealItem({
        ...state.editItem,
        unitAppraiseComId: state.taskID,
        appraiseAudsId: state.audID,
        appraiseAudsName: state.audName,
        appealContent: state.appealText,
        appealFileUrl: state.appealFile,
      });
      if (data.isSuccessful) {
        ElMessage({
          message: "操作成功",
          type: "success",
        });
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "[保存申诉项目]未知错误，请联系管理员",
          type: "error",
          grouping: true,
        });
      }
    };

    const handleChange = (index) => {
      // 下拉选择框
      state.audID = state.audItemList[index].id;
      state.audName = state.audItemList[index].name;
    };
    const showAdd = () => {
      state.addVisible = true;
    };


    const uploadHandler = async (param) => {
      const file = param.file;
      console.info("file", param.file.type);
      let formData = new FormData();
      formData.append("file", file);
      const fileName = file.name.substring(0, file.name.lastIndexOf("."))
      const { data } = await api.reviewTaskApi.saveFile({
        uappcomid: state.taskID,
        seqnum: "appeal",
        formData,
        fileName,
        file,
      });
      if (data.isSuccessful) {
        const fileUrl = data.resultObj[0];
        state.appealFile = fileUrl;
        ElMessage({
          message: "上传成功",
          type: "success",
        });
      } else {
        if (data.resultMsg) {
          ElMessage({
            message: data.resultMsg,
            type: "error",
          });
        } else {
          ElMessage({
            message: "未知错误，请联系管理员",
            type: "error",
          });
        }
      }
    };
    const getFileName = (val) => {
      if (val != null) {
        if (val || val != "") {
          console.info("fileurl", val);
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    };

    const revokeAppeal = async (id) => {
      state.addSearchLoading = true;
      const { data } = await api.auditionApi.revokeAppealListByTaskID(id);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
      state.addSearchLoading = false;
    };
    const advanceAppeal = async () => {
      const { data } = await api.auditionApi.advanceAppealList(state.taskID);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
    };
    const handleClose = () => {
      state.taskID = null;
      state.audID = null;
      state.audName = null;
      state.appealText = null;
      state.appealFile = null;
      state.editItem = null;
      state.addVisible = false;
      state.appealItem = null;
    };

    const showDetail = async (id) => {
      // const {data}=await api.reviewTaskApi.getReviewFormByID(id)
      // console.info("get review form",data)

      const path = `/system/audition/auditionDetail?unitAID=${id}`;
      const routerData = router.resolve(path);
      window.open(routerData.href, "_blank");
      return;
    };
    const replaceChinese = (str) => {
      str = str.replace(/[\u4e00-\u9fa5]/g, "");
      return str;
    }
    return {
      state,
      getTableData,
      handleClose,
      revokeAppeal,
      showDetail,
      showAdd,
      handleChange,
      uploadHandler,
      getFileName,
      saveAppealItem,
      advanceAppeal,
      replaceChinese
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.state.pageInfo.pageIndex = val;
      this.getTableData();
    },
    getBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
